import { RouterState } from "./router/router.state";
import { ApplicationState } from "./application/application.state";
import { SearchState as ContactSearchState } from "./contact-search/search.state";
import { ContactState } from "./contact/contact.state";
import { CompanyState } from "./company/company.state";
import {UserProfileState} from "./user-profile/user-profile.state";
import { createSelector } from "@ngrx/store";
import { TechStackState } from "./tect-stack/tech-stack.state";
import { TechStackInsightState } from "./insight/insight.state";

export interface IStore {
    router: RouterState;
    application: ApplicationState;
    contactSearch: ContactSearchState;
    contact: ContactState;
    company:CompanyState;
    userProfile:UserProfileState;
    techStack:TechStackState;
    techStackInsight:TechStackInsightState;
}

export const selectApplicationState = createSelector((state: IStore) => state.application, store => store);
